import React from "react";
import "./Hero.css";

const Hero = ({ title, subtitle, image, ctaText, ctaLink }) => {
  return (
    <div className="hero">
      <img src={image} alt="Hero Background" className="hero-image" />
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        {ctaText && ctaLink && (
          <a href={ctaLink} className="hero-cta-button">
            {ctaText}
          </a>
        )}
      </div>
    </div>
  );
};

export default Hero;
